import { onBeforeUnmount, watch, type Ref } from "vue";

// 实时变更订阅。
// EventSource 会自己重连，但重连期间错过的 change 事件不会补发，页面会一直停在旧数据 ——
// 所以重连成功（open 且不是首次）时回调 onReconnect，让上层做一次全量刷新。
export function useRealtime(onChange: (event: MessageEvent) => void, active: Ref<boolean>, onReconnect?: () => void) {
  let source: EventSource | undefined;
  let connected = false;
  function stop() {
    source?.close();
    source = undefined;
    connected = false;
  }
  function start() {
    stop();
    if (!active.value) return;
    source = new EventSource("/api/stream", { withCredentials: true });
    source.addEventListener("change", event => onChange(event as MessageEvent));
    source.addEventListener("open", () => {
      if (connected) onReconnect?.();
      connected = true;
    });
    source.addEventListener("error", () => {
      // 浏览器会自动重连；这里只标记断开，等 open 时再补拉一次。
      connected = false;
    });
  }
  watch(active, start, { immediate: true });
  onBeforeUnmount(stop);
}
